/**
 * Shared reCAPTCHA v3 helper (invisible).
 * Loads the Google script once and returns a fresh token on demand.
 */

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let scriptLoaded = false;

export function loadRecaptchaScript() {
  if (!RECAPTCHA_SITE_KEY || scriptLoaded) return;
  if (typeof document === "undefined") return;
  if (document.getElementById("google-recaptcha-v3-script")) {
    scriptLoaded = true;
    return;
  }
  const s = document.createElement("script");
  s.id = "google-recaptcha-v3-script";
  s.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
  s.async = true;
  s.defer = true;
  document.head.appendChild(s);
  scriptLoaded = true;
}

export function getRecaptchaToken(action = "submit") {
  return new Promise((resolve) => {
    if (!RECAPTCHA_SITE_KEY || typeof window === "undefined" || !window.grecaptcha) {
      resolve("");
      return;
    }
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
        resolve(token || "");
      } catch (_) {
        resolve("");
      }
    });
  });
}
